// src/components/auth/AdminRoute.tsx
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useIsAdmin } from '@/hooks/useIsAdmin';

/**
 * AdminRoute component
 * Protects routes that require admin access
 * Redirects non-admin users to dashboard
 */
export default function AdminRoute() {
  const { session, user, loading: authLoading } = useAuth();
  const { isAdmin, isLoading: adminCheckLoading } = useIsAdmin();
  const location = useLocation();

  const isLoading = authLoading || adminCheckLoading;

  // Show loading spinner while checking authentication and admin status
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-900">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 dark:border-blue-400 mx-auto mb-4"></div>
          <p className="text-gray-600 dark:text-gray-400">Checking access permissions...</p>
        </div>
      </div>
    );
  }

  // Not logged in -> Redirect to login
  if (!session || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Logged in but not admin -> Redirect to dashboard with error message
  if (!isAdmin) {
    return <Navigate to="/dashboard/dashboard" replace />;
  }

  // User is admin -> Allow access
  return <Outlet />;
}